import React from 'react'

import { Button, makeStyles, Theme } from '@material-ui/core'
import { typographyStyle } from '../../theme/typographyStyle'

const useStyles = makeStyles((theme: Theme) => ({
    button: {
        textTransform: 'none',
        width: '110px',
        height: '32px',
        fontSize: typographyStyle(theme.typography.button).fontSize,
    },
}))

interface ChartToggleButtonProps {
    showTrend: boolean
    onChange: () => void
}

const ChartToggleButton: React.FC<ChartToggleButtonProps> = ({
    showTrend,
    onChange,
}) => {
    const classes = useStyles()

    return (
        <Button
            variant="outlined"
            color="primary"
            size="small"
            className={classes.button}
            onClick={onChange}
        >
            {showTrend ? 'Show Totals' : 'Show Trend'}
        </Button>
    )
}

export default ChartToggleButton
